import styled from "styled-components";

export const ClassworkPageContainer = styled.div`
  --topbar-height: 8rem;

  background-color: ${({ theme }) => theme.classwork.backgroundColor};
  margin-top: var(--topbar-height);
  height: calc(100% - var(--topbar-height));

  .top {
    position: sticky;
    top: 0;
    left: 0;
  }

  .container {
    display: grid;
    align-items: start;
    grid-template-columns: 30% 60%;
    grid-gap: 10%;
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 1rem 0 1rem;
    position: relative;
    height: 100%;

    .group-image-container {
      position: sticky;
      top: 5rem;
    }
  }

  .topic-content-container {
    max-height: calc(100vh - var(--topbar-height));
    transition: all 100ms ease-in-out;
    padding: 80px 0;

    margin: 0;

    overflow-y: scroll;
  }

  @media screen and (max-width: 900px) {
    padding: 1rem 0;

    .container {
      grid-template-columns: 100%;
      grid-gap: 2rem;
      padding: 0 0.5rem;

      .group-image-container {
        aspect-ratio: 15 / 6;
        width: 100%;

        position: initial;
        top: initial;
      }
    }

    .classwork-title-image {
    }

    .topic-content-container {
      padding-top: 0;
      max-height: 100%;
    }
  }
`;
